import Vue from 'vue'
export const Service = Vue.extend({})
